import React, { useState, useEffect } from 'react';
import { Link, useLocation } from '@reach/router';
import { Nav, NavItem, NavLink } from 'react-bootstrap';
import styled from "styled-components";


export function Overlay() {
  // Always get the current route.
  const location = useLocation();

  // Always call hooks unconditionally.
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Update window width on resize.
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Simulate a loading delay (for demo, 3 seconds).
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  // Now, conditionally render content based on the route.
  // This ensures that all hooks are called every render.
  if (location.pathname !== '/') {
    return null;
  }

  // While loading, show the luxurious loading screen.
  if (isLoading) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'linear-gradient(135deg, #e5dfca, #eaeaea',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1200,
        }}
      >
        <div style={{ textAlign: 'center', color: '#FFD700' }}>
          {/* Luxurious Spinner */}
          <div
            style={{
              margin: '0 auto',
              width: '80px',
              height: '80px',
              border: '8px solid #3e3e3d', // subtle gold tint
              borderTop: '8px solid white',  // gold accent
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
            }}
          ></div>
          {/* Shimmering Loading Text */}
          <p
            style={{
              marginTop: '20px',
              fontSize: '20px',
              letterSpacing: '2px',
              fontFamily: '"Orbitron", sans-serif', // elegant serif font
              animation: 'shimmer 2s ease-in-out infinite',
              color:"#2e2e2d"
            }}
          >
            Ciega Labs...
          </p>
        </div>
        <style>{`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          @keyframes shimmer {
            0% { opacity: 0.7; }
            50% { opacity: 1; }
            100% { opacity: 0.7; }
          }
        `}</style>
      </div>
    );
  }

  // Determine if we're in mobile mode (screen width less than 600px).
  const isMobile = windowWidth < 600;

  // "CIEGA" branding element styling.
  const ciegaStyle = isMobile
    ? { position: 'absolute', top: 20, left: 10 }
    : { position: 'absolute', top: 40, left: '10vh' };

  // Desktop navigation styling.
  const worksNavStyle = {
    display: isMobile ? 'none' : 'block',
    position: 'absolute',
    top: 40,
    right: 300,
    fontSize: '15px',
    textAlign: 'right',
  };

  const contactNavStyle = {
    display: isMobile ? 'none' : 'block',
    position: 'absolute',
    top: 40,
    right: 170,
    fontSize: '15px',
    textAlign: 'right',
  };

  const aboutNavStyle = {
    display: isMobile ? 'none' : 'block',
    position: 'absolute',
    top: 40,
    right: 100,
    fontSize: '15px',
    textAlign: 'right',
  };

  // Date element styling.
  const dateStyle = {
    position: 'absolute',
    top: 40,
    right: 40,
    fontSize: '15px',
    textAlign: 'right',
    fontVariantNumeric: 'tabular-nums',
  };

  // Hamburger menu icon styling (only visible on mobile).
  const hamburgerStyle = {
    display: isMobile ? 'flex' : 'none',
    position: 'absolute',
    top: 40,
    right: 10,
    width: 30,
    height: 30,
    cursor: 'pointer',
    flexDirection: 'column',
    justifyContent: 'space-around',
    zIndex: 1100,
  };

  const hamburgerLineStyle = {
    width: '100%',
    height: 3,
    backgroundColor: 'black',
  };

  // Mobile menu popup styling (only visible on mobile when toggled).
  const mobileMenuStyle = {
    display: mobileMenuOpen ? 'flex' : 'none',
    position: 'absolute',
    top: 80,
    right: 10,
    backgroundColor: 'white',
    border: '1px solid #ccc',
    padding: 10,
    zIndex: 1000,
    flexDirection: 'column',
  };

  const NavItem = styled(Link)`
  margin: 0 1rem;
  text-decoration: none;
  font-size: 1rem;
  cursor: pointer;
  transition: transform 0.3s ease;

  /* Force white color on all states */
  color: white !important;
  &:link,
  &:visited,
  &:hover,
  &:active {
    color: white !important;
    text-decoration: none;
  }

  &:hover {
    transform: scale(1.05);
  }
`;

  return (
    <>
      {/* "CIEGA" branding */}
      <div className="char" style={ciegaStyle}>
        CIEGA
      </div>

      {/* "LABS" branding */}
      <div
        className="char"
        style={{
          position: 'absolute',
          bottom: 40,
          left: '40vw',
        }}
      >
        LABS
      </div>

      {/* Desktop Navigation: Works & Case Studies */}


      
         <div style={worksNavStyle}>
         <NavItem to="/case-studies">

        <p
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'black',
            textDecoration: 'none',
            transition: 'color 0.3s',
          }}
          onMouseEnter={(e) => (e.target.style.color = 'white')}
          onMouseLeave={(e) => (e.target.style.color = 'black')}
        >
          WORKS &<br />
          CASE STUDIES
        </p>
              </NavItem>

      </div>


      {/* Desktop Navigation: Contact */}
      <div style={contactNavStyle}>
          <NavItem to="/contact">
                <p
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'black',
            textDecoration: 'none',
            transition: 'color 0.3s',
          }}
          onMouseEnter={(e) => (e.target.style.color = 'white')}
          onMouseLeave={(e) => (e.target.style.color = 'black')}
        >
          CONTACT
        </p>
          </NavItem>


      </div>

      <div style={aboutNavStyle}>
          <NavItem to="/about">
                <p
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'black',
            textDecoration: 'none',
            transition: 'color 0.3s',
          }}
          onMouseEnter={(e) => (e.target.style.color = 'white')}
          onMouseLeave={(e) => (e.target.style.color = 'black')}
        >
          ABOUT
        </p>
          </NavItem>


      </div>

      

      {/* Date */}
      <div style={dateStyle}>
        {/* —<br /> */}
        {/* 08/01/22 */}
      </div>

      {/* Hamburger Menu Icon (only shown on mobile) */}
      <div
        style={hamburgerStyle}
        onClick={() => setMobileMenuOpen((prev) => !prev)}
      >
        <div style={hamburgerLineStyle} />
        <div style={hamburgerLineStyle} />
        <div style={hamburgerLineStyle} />
      </div>

      {/* Mobile Menu Popup (only shown on mobile when toggled) */}
  
      <div style={mobileMenuStyle}>
        <a
          href="/case-studies"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'black',
            textDecoration: 'none',
            transition: 'color 0.3s',
            marginBottom: '10px',
          }}
          onMouseEnter={(e) => (e.target.style.color = 'white')}
          onMouseLeave={(e) => (e.target.style.color = 'black')}
        >
          WORKS &<br />
          CASE STUDIES2
        </a>
        <a
          href="/contact"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'black',
            textDecoration: 'none',
            transition: 'color 0.3s',
          }}
          onMouseEnter={(e) => (e.target.style.color = 'white')}
          onMouseLeave={(e) => (e.target.style.color = 'black')}
        >
          CONTACT
        </a>
      </div>

      {/* Bottom Information Block */}
      <div
        style={{
          position: 'absolute',
          bottom: 120,
          left: 120,
          fontSize: '18px',
        }}
      >
         {/* SEE OUR PRODUCTS */}

        <br />
        <NavItem to="/products">

        <div
          style={{
            position: 'relative',
            marginTop: 10,
            display: 'inline-block',
          }}
        >

          <p style={{ fontSize: '15px', fontWeight: 600, letterSpacing: 2 }}>
            <p
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: 'black',
                textDecoration: 'none',
                transition: 'color 0.3s',
              }}
              onMouseEnter={(e) => (e.target.style.color = 'white')}
              onMouseLeave={(e) => (e.target.style.color = 'black')}
            >
              OUR PRODUCTS
            </p>
          </p>

          <div
            style={{
              marginTop: 6,
              height: 2.5,
              width: '100%',
              background: '#3e3e3d',
            }}
          />
        </div>
        </NavItem>
        <br />
      </div>
    </>
  );
}
